module.exports = __webpack_public_path__ + "static/img/top-tabs-title-pic2.ca09bd71.png";